import type { Template } from "@/hooks/useTemplates"
import type { AspectRatio } from "@/lib/constants"
import type { ReferenceImage, ApplyableSettings } from "@/types/generation"
import { localizeTextPrompt } from "@/lib/i18n-content"

/** 썸네일 URL에 캐시 버스팅 파라미터 추가 */
function withCacheBusting(url: string | null, updatedAt: string): string | null {
  if (!url) return null
  const timestamp = new Date(updatedAt).getTime()
  return `${url}?v=${timestamp}`
}

/**
 * Template에서 ApplyableSettings로 변환
 * 스타일은 백엔드에서 적용되므로 templateId만 전달
 */
export function extractSettingsFromTemplate(template: Template): ApplyableSettings {
  const referenceImages: ReferenceImage[] = template.referenceImages.map((ref, idx) => ({
    id: `template-${template.id}-${idx}`,
    s3Key: ref.s3Key,
    thumbnailS3Key: ref.thumbnailS3Key,
    url: ref.thumbnailUrl,
    thumbnailUrl: ref.thumbnailUrl,
    width: 256,
    height: 256,
  }))

  return {
    // 현재 UI 언어의 번역 프롬프트로 채운다 (없으면 ko 원문 폴백). 파라미터 KEY 는 언어 무관 동일.
    prompt: localizeTextPrompt(template),
    // style은 백엔드에서 템플릿 기반으로 적용되므로 전달하지 않음
    // aspectRatio가 유효한 값일 때만 적용 (null, undefined, '' 제외)
    aspectRatio: template.aspectRatio ? (template.aspectRatio as AspectRatio) : undefined,
    referenceImages: referenceImages.length > 0 ? referenceImages : undefined,
    // 템플릿 정보 (백엔드에서 스타일/promptSuffix 적용 + UI 표시용)
    template: {
      id: template.id,
      name: template.name,
      description: template.description,
      nameI18n: template.nameI18n,
      descriptionI18n: template.descriptionI18n,
      thumbnailUrl: withCacheBusting(template.thumbnailUrl, template.updatedAt),
    },
  }
}

export function toTemplateThumbnailUrl(url: string | null, updatedAt: string): string | null {
  return withCacheBusting(url, updatedAt)
}
